module.exports = __webpack_public_path__ + "static/media/cornell-logo-3 1.edbaa943.png";